export type APIMessage = 'Success' | 'Fail'

export enum ErroCodes {
  LOGIN_REQUIRED = 'LOGIN_REQUIRED',
  UNAUTHORIZED_VIEW = 'UNAUTHORIZED_VIEW',
  URL_NOT_FOUND = 'URL_NOT_FOUND',
  WITHOUT_CODE = 'WITHOUT_CODE',
  INVERIFIED_PHONE = 'INVERIFIED_PHONE',
  INVALID_INPUT = 'INVALID_INPUT',
  UNAUTHENTICATED_SUBSCRIPTION = 'Unauthenticated_SUBSCRIPTION',
}

export interface IAPIRes<T> {
  data: T
  error_code: ErroCodes
  msg: APIMessage
}

export enum APIMessageEnum {
  Success = 'Success',
  Fail = 'Fail'
}

export interface IAPIErrorRes {
  msg?: APIMessage
  success?: boolean
  data?:
    | {
        [key: string]: string[]
      }
    | string
  errors: {
    [key: string]: string[]
  }
  error_code: ErroCodes
}
